import config from "../../config";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import SideMenu from "./sideMenu";
import MaterialTable from "material-table";
import { tableIcons } from "../../tableIcons";
import { TablePagination } from "@material-ui/core";
import moment from "moment";
import { DatePicker, Tabs, Card, Select, Button, Alert } from "antd";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import CustomTabs from "../tabs";
import AnalyticsCard from "../analyticsCard";
import CustomTable from "../table";
import dayjs from "dayjs";
import Reports from "../dashboard/reports";
import ReportProfitAndLoss from "./report-profitAndLoss";
import { useAccess } from "../../provider/AccessProvider";
import { REPORTACCESS } from "../../utils/constant";
import { useHotkeys } from "react-hotkeys-hook";
const { RangePicker } = DatePicker;

const StockValueReport = () => {
  const [dates, setDates] = useState([dayjs(), dayjs()]);
  const [value, setValue] = useState([dayjs(), dayjs()]);
  // ShortCutKey
  useEffect(() => {
    function keydownHandler(event) {
      event.stopImmediatePropagation();
      if (event.altKey && event.keyCode == 83) {
        // Search (S)tableSearchSelect
        let input = document.querySelector(
          "#tableSearchSelect .MuiInputBase-input"
        );
        if (input) input.focus();
      } else if (event.altKey && event.keyCode == 69) {
        // Export (E)
        let input = document.querySelectorAll(".MuiIconButton-colorInherit");
        if (input[1]) {
          input[1].click();
          const exportBtn = document.querySelector(
            ".MuiButtonBase-root.MuiListItem-root.MuiMenuItem-root.MuiMenuItem-gutters.MuiListItem-gutters.MuiListItem-button"
          );
          exportBtn.click();
        }
      }
    }
    document.addEventListener("keydown", keydownHandler, false);
    return () => {
      window.removeEventListener("keydown", keydownHandler, false);
    };
  });

  const [products, setProducts] = useState([]);
  const [totalStockValue, setTotalStockValue] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [taxList, setTaxList] = useState([]);
  const [taxLoader, setTaxLoader] = useState(true);
  const [tab, setTab] = useState("stockValueReport");
  const currentData = moment();
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [billList, setBillList] = useState([]);
  const [employeeArr, setEmployeeArr] = useState([]);
  const [viewTrigger, setViewTrigger] = useState(true);
  const [csvLoader, setCsvLoader] = useState(false);
  const [stockTrackerArray, setStockTrackerArray] = useState([]);
  const [inventoryProducts, setInventoryProducts] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  const [totalSales, setTotalSales] = useState(0);
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const shopDetails = useSelector((state) => state.shopDetails);
  const access = useAccess(REPORTACCESS);
  const getTaxMaster = (taxId) => {
    return taxList?.find((tax) => tax.taxId === taxId) || {};
  };
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const [originalDataOfSoldProducts, setOriginalDataOfSoldProducts] = useState(
    []
  );
  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate =
      (dates[0] && current.diff(dates[0], "days") > 30) || current > dayjs();
    const tooEarly = dates[1] && dates[1].diff(current, "days") > 30;
    return !!tooEarly || !!tooLate;
  };
  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };
  useEffect(() => {
    const fetchTaxsList = async (shopId) => {
      setTaxLoader(true);
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          action: "fetchTaxmaster",
          shopId: shopId,
        }),
      });
      setTaxLoader(false);
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      setTaxList(res.data);
    };
    if (shopId) {
      fetchTaxsList(shopId);
      fetchEmployee();
    }
  }, [shopId]);

  useEffect(() => {
    if (billList.length > 0) {
      var obj = {};

      billList.map((data) => {
        data.items.map((value) => {
          if (
            !value.returned ||
            parseFloat(value.returned) !== parseFloat(value.count)
          ) {
            // if (value.productId === "74ac8cb5-3986-4355-baa7-51e5f0b1ec39") {
            //   console.log("objobj2", obj[value?.productId], value);
            // }

            if (obj.hasOwnProperty(value.productId)) {
              obj[value.productId].count =
                parseFloat(obj[value.productId].count) +
                parseFloat(value.count) -
                parseFloat(value.returned || 0);
            } else {
              obj[value.productId] = {
                ...value,
                count: value.returned
                  ? parseFloat(value.count) - parseFloat(value.returned || 0)
                  : value.count,
              };
            }
          }
        });
      });

      var soldIds = Object.keys(obj);

      var soldProductsLiveData = inventoryProducts.filter((data) => {
        if (soldIds.includes(data.productId)) {
          return data;
        }
      });
      var soldProductsLiveDataIds = soldProductsLiveData.map((data) => {
        return data.productId;
      });
      var fer = [...new Set(soldProductsLiveDataIds)];

      console.log("soldIds", soldIds, fer, obj);

      // soldIds.map((data) => {
      //   if (!fer.includes(data)) {
      //     obj[data].inventoryQty = "N/A";
      //   }
      // });

      // var temobj = {};
      // soldProductsLiveData.map((data) => {
      //   if (temobj.hasOwnProperty(data.productId)) {
      //     temobj[data.productId].push(data);
      //   } else {
      //     temobj[data.productId] = [data];
      //   }
      // });
      // console.log("tempObj", temobj);
      // var twoVersionData = Object.values(temobj)
      // twoVersionData.map((data)=>{
      //   if(data.length > 1){
      //     data.map((value)=>{
      //     })
      //   }
      // })

      let tempData = [];
      console.log("soldProductsLiveData", obj, soldProductsLiveData);

      soldProductsLiveData.map((data) => {
        if (obj.hasOwnProperty(data.productId)) {
          console.log(" obj[data.productId]", obj[data.productId]);
          tempData.push(data);

          obj[data.productId].inventoryQty = data.inventoryQty;
          obj[data.productId].productName = data.productName;
          obj[data.productId].productBrand = data.productBrand;
          obj[data.productId].productHsnCode = data.productHsnCode;
        }
      });

      setStockTrackerArray([...Object.values(obj)]);
      obj = {};
    } else {
      setStockTrackerArray([]);
    }
  }, [billList]);

  const getProductDetails = async () => {
    if (shopId === "") return;
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          type: "getProductDetails",
          userId: shopId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.limitExceeds && data.status) {
          try {
            var productData = await fetch(data.products);
            productData = await productData.json();
            processStockValueForProduct(productData);
            setInventoryProducts(productData);

            return;
          } catch (err) {
            alert("Failed to fetch product details. Please try again");
            return;
          }
        }
        setIsLoading(false);
        processStockValueForProduct(data.products);
        setInventoryProducts(data.products);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Err", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const processStockValueForProduct = (data) => {
    var tempProd = [];
    var tempTotalStockValue = 0;
    data.map((data) => {
      if (data.productType && data.productType === "service") {
        return;
      }
      if (data.inventoryQty && data.productPrice !== "TBD") {
        var mul = (
          parseFloat(data.inventoryQty) * parseFloat(data.productPrice)
        ).toFixed(2);
        if (mul > 0) {
          data.productStockValue = mul;
          tempTotalStockValue += parseFloat(mul);
          tempProd.push(data);
        }
      }
    });
    setProducts(tempProd);
    setTotalStockValue(tempTotalStockValue.toFixed(2));
  };

  useEffect(() => {
    getProductDetails();
  }, [shopId]);

  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;

    return (
      <TablePagination
        {...tablePaginationProps}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }
  const columnsData = useMemo(() => {
    const result = products.map((data) => {
      const taxMaster = getTaxMaster(data.taxId);
      let tax = taxMaster.taxName ? taxMaster.taxName + "(" : "-";
      taxMaster.taxType?.forEach((element) => {
        const taxName =
          customTaxType.find((customTax) => customTax.taxId === element)
            ?.taxName || element;
        const label =
          customTaxType.find((customTax) => customTax.taxId === element)
            ?.label || element;
        tax = tax + " " + label + "-" + taxMaster[taxName] + "%";
      });
      return {
        ...data,
        productTax:
          data?.taxId && Object.keys(taxMaster)?.length !== 0
            ? tax + ")"
            : data?.productTax
            ? `${data?.productTax}%`
            : data?.productTaxType
            ? `${data?.productTaxType}%`
            : "-",
      };
    });
    return result;
  }, [products]);
  //stock tracker starts here

  const fetchSalesReport = async (payload, fromDate, toDate) => {
    console.log("salesreport inital payload", payload);
    try {
      let res = await fetch(
        `${config.newApiGateway}/analytics/getSalesReports`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopId,
            from: fromDate,
            to: toDate,
            // employeeId: shopDetails.empId ? shopDetails.empId : "",
            employeeId: selectedEmployee ? selectedEmployee : "",
            lastItem: undefined,
            ...payload,
          }),
        }
      );
      res = await res.json();
      setBillList((prev) => {
        return [...prev, ...res.bills];
      });
      return res;
    } catch (err) {
      console.log("err", err);
    }
  };
  useEffect(() => {
    if (shopId) {
      if (!value) {
        return alert("Please select date");
      }

      const fromDate =
        (dates && dates[0].format("YYYY-MM-DD")) ||
        (value && value[0].format("YYYY-MM-DD"));
      const toDate =
        (dates && dates[1].format("YYYY-MM-DD")) ||
        (value && value[1].format("YYYY-MM-DD"));
      console.log("fromDate", { fromDate, toDate });
      getSalesReports(fromDate, toDate);
    }
  }, [viewTrigger, shopId]);

  const fetchEmployee = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
        {
          method: "post",
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            action: "fetchEmployee",
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        setEmployeeArr(res.data);
      } else {
        // alert(res.message);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const getSalesReports = async (fromDate, toDate) => {
    try {
      setBillList([]);
      let res = await fetchSalesReport(undefined, fromDate, toDate);
      // setIsLoading(false);
      while (res.lastItem) {
        // setFetchLoading(true);
        const nextRespones = await fetchSalesReport(
          { lastItem: res.lastItem },
          fromDate,
          toDate
        );
        res = nextRespones;
      }
      // setFetchLoading(false);
    } catch (err) {
      console.log(err);
    } finally {
      setViewTrigger(false);
    }
  };

  const reportColumns = [
    {
      title: "Product Name",
      fixed: "left",
      dataIndex: "productName",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Product Brand",
      dataIndex: "productBrand",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Product Category",
      dataIndex: "category",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Product Sub-Category",
      dataIndex: "subCategory",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Inventory Qty",
      dataIndex: "inventoryQty",
      cellStyle: {
        textAlign: "center",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: `MRP (${country.CurrencySymbol})`,
      cellStyle: {
        textAlign: "center",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      render: (rowData) => {
        return rowData.productMrp ? currencyFormatter(rowData.productMrp) : "";
      },
    },
    {
      title: `Selling Price(${country.CurrencySymbol})`,
      cellStyle: {
        textAlign: "center",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      render: (rowData) => {
        return rowData.productPrice
          ? currencyFormatter(rowData.productPrice)
          : "";
      },
    },
    {
      title: "Purchase price",
      cellStyle: {
        textAlign: "center",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      render: (rowData) => {
        return rowData.purchasePrice
          ? currencyFormatter(rowData.purchasePrice)
          : "";
      },
    },
    {
      title: "EAN Code",
      dataIndex: "productEANCode",
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "HSN Code",
      dataIndex: "productHsnCode",
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Product Code",
      dataIndex: "productCode",
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Product Tax",
      dataIndex: "productTax",
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Inclusive/Exclusive",
      dataIndex: "taxIncExc",
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: `Stock Value(${country.CurrencySymbol})`,
      dataIndex: "productStockValue",
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      cellStyle: {
        textAlign: "center",
        whiteSpace: "nowrap",
      },
    },
  ];
  const trackerColumns = [
    {
      title: "Product Name",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      render: (stockTrackerArray) => {
        return (
          <div>
            {stockTrackerArray.productName}
            {stockTrackerArray?.parentProductId &&
              stockTrackerArray.parentProductId !== " " && (
                <> ({stockTrackerArray?.unitOfMeasurment})</>
              )}
          </div>
        );
      },
    },
    {
      title: "Product Brand",
      dataIndex: "productBrand",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Inventory",
      dataIndex: "inventoryQty",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Sold Quantity",
      dataIndex: "count",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
    {
      title: "HSN Code",
      dataIndex: "productHsnCode",
      cellStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
      headerStyle: {
        textAlign: "left",
        whiteSpace: "nowrap",
      },
    },
  ];
  const exportHead = [
    "Product Name",
    "Product Brand",
    "Inventory",
    "Sold Quantity",
    "HSN Code",
  ];
  const exportValue = [
    "productName",
    "productBrand",
    "inventoryQty",
    "count",
    "productHsnCode",
  ];
  const exportHeadStockValue = [
    "Product Name",
    "Product Brand",
    "Product Category	",
    "Product Sub-Category",
    "Inventory Qty",
    "MRP",
    "Selling Price",
    "Purchase price",
    "EAN Code",
    "HSN Code",
    "Product Code",
    "Product Tax",
    "Inclusive/Exclusive",
    "Stock Value",
  ];
  const safe = (v) => (v === null || v === "" || v === undefined ? "0" : v);

  const exportValueStockValue = [
    { field: "productName", render: (row) => safe(row.productName) },
    { field: "productBrand", render: (row) => safe(row.productBrand) },
    { field: "category", render: (row) => safe(row.category) },
    { field: "subCategory", render: (row) => safe(row.subCategory) },
    { field: "inventoryQty", render: (row) => safe(row.inventoryQty) },
    { field: "productMrp", render: (row) => safe(row.productMrp) },
    { field: "productPrice", render: (row) => safe(row.productPrice) },
    { field: "purchasePrice", render: (row) => safe(row.purchasePrice) },
    { field: "productEANCode", render: (row) => safe(row.productEANCode) },
    { field: "productHsnCode", render: (row) => safe(row.productHsnCode) },
    { field: "productCode", render: (row) => safe(row.productCode) },
    { field: "productTax", render: (row) => safe(row.productTax) },
    { field: "taxIncExc", render: (row) => safe(row.taxIncExc) },
    { field: "productStockValue", render: (row) => safe(row.productStockValue) },
  ];
  
  useHotkeys("alt + d", () => {
    document.getElementById("reportDownloadBtn")?.click();
  });

  if (!access.reports(false)) {
    return (
      <Alert
        style={{ marginTop: "20px", padding: "20px", textAlign: "center" }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }

  return (
    <>
      <div>
        <div>
          <CustomTabs
            style={{
              marginBottom: 20,
            }}
            activeKey={activeKey}
            onTabChange={(v) => setActiveKey(v)}
          >
            <Tabs.TabPane tab="Sales Report" key={"1"} />

            {shopDetails?.advanceSettings?.b2bPricing && (
              <Tabs.TabPane tab="B2B Sales Report" key={"2"} />
            )}

            <Tabs.TabPane tab="Stock Value Report" key={"3"} />
            <Tabs.TabPane tab="Stock Tracker" key={"4"} />
            <Tabs.TabPane tab="Profit/Loss" key={"5"} />
          </CustomTabs>
          {activeKey === "1" && (
            <ReportProfitAndLoss
              tab="reports"
              totalSales={totalSales}
              setTotalSales={setTotalSales}
            />
          )}
          {activeKey === "2" && (
            <ReportProfitAndLoss
              tab="b2bSalesReport"
              totalSales={totalSales}
              setTotalSales={setTotalSales}
            />
          )}
          {activeKey === "3" && (
            <>
              {!access.stockReport(false) ? (
                <Alert
                  style={{
                    padding: "20px",
                    textAlign: "center",
                    marginTop: 20,
                  }}
                  message="You don't have access, Please contact your administrator to request the appropriate access."
                  type="error"
                />
              ) : (
                <>
                  <AnalyticsCard
                    value="Total Stock Value"
                    label={currencyFormatter(totalStockValue)}
                    showIcon={false}
                    style={{
                      margin: "0 auto 20px",
                      textAlign: "center",
                    }}
                  />
                  <CustomTable
                    data={columnsData}
                    title={"Stock Value Report"}
                    columns={reportColumns}
                    loading={isLoading}
                    excelExport={true}
                    exportHead={exportHeadStockValue}
                    exportValue={exportValueStockValue}
                  />
                </>
              )}
            </>
          )}
          {activeKey === "4" && (
            <>
              {!access.stockTracker(false) ? (
                <Alert
                  style={{
                    padding: "20px",
                    textAlign: "center",
                    marginTop: 20,
                  }}
                  message="You don't have access, Please contact your administrator to request the appropriate access."
                  type="error"
                />
              ) : (
                <>
                  <Card
                    id="report-card"
                    style={{
                      marginBottom: 20,
                    }}
                  >
                    <div
                      style={{
                        width: 400,
                        display: "inline-block",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <span> From </span>
                        <span
                          style={{
                            margin: "0 auto",
                          }}
                        >
                          To{" "}
                        </span>
                      </div>
                      <RangePicker
                        //value={dates || value}
                        style={{
                          width: "400px",
                        }}
                        size="medium"
                        disabledDate={disabledDate}
                        onCalendarChange={(val) => setDates(val)}
                        onChange={(val) => setValue(val)}
                        onOpenChange={onOpenChange}
                      />
                    </div>
                    <div
                      style={{
                        display: "inline-block",
                      }}
                    >
                      <div>Users</div>
                      <Select
                        onChange={(value) => {
                          if (value === "All Employees") {
                            setSelectedEmployee("");
                          } else {
                            setSelectedEmployee(value);
                          }
                        }}
                        placeholder="All Employees"
                        allowClear
                      >
                        {employeeArr.map((data) => (
                          <Select.Option value={data.userId}>
                            {data.userName}{" "}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                    <Button
                      onClick={() => {
                        setViewTrigger(true);
                      }}
                      type="primary"
                      size="medium"
                      disabled={isLoading}
                      ghost
                    >
                      View
                    </Button>
                  </Card>
                  <CustomTable
                    columns={trackerColumns}
                    data={stockTrackerArray}
                    title={"Stock Tracker"}
                    excelExport={true}
                    exportHead={exportHead}
                    exportValue={exportValue}
                  />
                </>
              )}
            </>
          )}
          {activeKey === "5" && (
            <ReportProfitAndLoss
              tab="profitAndLoss"
              totalSales={totalSales}
              setTotalSales={setTotalSales}
            />
          )}

          {/* <div className="stockValueReportButtons">
            <div>
              {" "}
              <input
                type="radio"
                onClick={() => setTab("stockValueReport")}
                checked={tab == "stockValueReport"}
                id="stockValueReportId"
                className="stockValueReportRadio"
              />{" "}
              <label
                for="stockValueReportId"
                className={
                  tab == "stockValueReport"
                    ? "stockValueReportChecked"
                    : "stockValueReportUnChecked"
                }
              >
                Stock Value Report
              </label>
            </div>
            <div>
              {" "}
              <input
                type="radio"
                onClick={() => setTab("stockTracker")}
                checked={tab == "stockTracker"}
                id="stockTrackerId"
                className="stockTrackerRadio"
              />{" "}
              <label
                for="stockTrackerId"
                className={
                  tab == "stockTracker"
                    ? "stockValueReportChecked"
                    : "stockValueReportUnChecked"
                }
              >
                Stock Tracker
              </label>
            </div>
          </div> */}
        </div>
        {/* {tab == "stockValueReport" && (
          <div className="totalStockValueCard">
            <div
              className="card-style"
              style={{
                width: "auto",
                maxWidth: 400,
              }}
            >
              <h5>Total Stock Value</h5>
              <h2>{currencyFormatter(totalStockValue)}</h2>
            </div>
          </div>
        )} */}
        {/* {tab == "stockValueReport" && (
          <div id="tableSearchSelect" className="stockValueTable">
            <MaterialTable
              columns={[
                {
                  title: "Product Name",
                  field: "productName",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Product Brand",
                  field: "productBrand",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Product Category",
                  field: "category",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Product Sub-Category",
                  field: "subCategory",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Inventory Qty",
                  field: "inventoryQty",
                  cellStyle: {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: `MRP (${country.CurrencySymbol})`,
                  field: "productMrp",
                  cellStyle: {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  render: (rowData) => {
                    return rowData.productMrp
                      ? currencyFormatter(rowData.productMrp)
                      : "";
                  },
                },
                {
                  title: `Selling Price(${country.CurrencySymbol})`,
                  field: "productPrice",
                  cellStyle: {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  render: (rowData) => {
                    return rowData.productPrice
                      ? currencyFormatter(rowData.productPrice)
                      : "";
                  },
                },
                {
                  title: "Purchase price",
                  field: "purchasePrice",
                  cellStyle: {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  render: (rowData) => {
                    return rowData.purchasePrice
                      ? currencyFormatter(rowData.purchasePrice)
                      : "";
                  },
                },
                {
                  title: "EAN Code",
                  field: "productEANCode",
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "HSN Code",
                  field: "productHsnCode",
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Product Code",
                  field: "productCode",
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Product Tax",
                  field: "productTax",
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Inclusive/Exclusive",
                  field: "taxIncExc",
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: `Stock Value(${country.CurrencySymbol})`,
                  field: "productStockValue",
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  cellStyle: {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  },
                },
              ]}
              data={columnsData}
              icons={tableIcons}
              title="Stock Value Report"
              isLoading={isLoading}
              options={{
                search: true,
                exportButton: {
                  csv: true,
                },
                exportAllData: true,
                columnsButton: true,
              }}
              components={{
                Pagination: PatchedPagination,
              }}
            />
          </div>
        )} */}
        {tab == "stockTracker" && (
          <div id="tableSearchSelect" className="stockValueTable">
            {/* {console.log("stockTrackerArray", stockTrackerArray)} */}
            <MaterialTable
              columns={[
                {
                  title: "Product Name",
                  field: "productName",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  render: (stockTrackerArray) => {
                    return (
                      <div>
                        {stockTrackerArray.productName}
                        {stockTrackerArray?.parentProductId &&
                          stockTrackerArray.parentProductId !== " " && (
                            <> ({stockTrackerArray?.unitOfMeasurment})</>
                          )}
                      </div>
                    );
                  },
                },
                {
                  title: "Product Brand",
                  field: "productBrand",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Inventory",
                  field: "inventoryQty",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "Sold Quantity",
                  field: "count",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
                {
                  title: "HSN Code",
                  field: "productHsnCode",
                  cellStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                  headerStyle: {
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  },
                },
              ]}
              data={stockTrackerArray}
              icons={tableIcons}
              title="Stock Tracker"
              isLoading={isLoading}
              options={{
                search: true,
                exportButton: {
                  csv: true,
                },
                exportAllData: true,
                columnsButton: true,
              }}
              components={{
                Pagination: PatchedPagination,
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default StockValueReport;
